import React from "react";
import { IconButton, Typography } from "@mui/material";
import {
  Edit as EditIcon,
  Close as CloseIcon,
  AccessTime as ClockIcon,
} from "@mui/icons-material";
import { motion } from "framer-motion";
import EditPresetForm from "./EditPresetForm";
import * as S from "./styles";

const formatTimeString2 = (time) => {
  if (!time) return "00:00";
  return time.padStart(5, "0");
};

function PresetCard({
  preset,
  editingPreset,
  setEditingPreset,
  editMutation,
  deletePresetMutation,
  openSnackbar,
  group_code,
  project_code,
  shiftsData,
}) {
  const handleStartEdit = (preset) => {
    const validatedSchedules = preset.schedules.map((schedule) => ({
      ...schedule,
      start: formatTimeString2(schedule.start),
      end: schedule.end === "24:00" ? "00:00" : formatTimeString2(schedule.end),
      isUntilMidnight: schedule.end === "24:00",
    }));
    setEditingPreset({
      ...preset,
      schedules: validatedSchedules,
    });
  };
  const deletePreset = (presetId) => {
    if (
      window.confirm(
        "해당 프리셋을 사용하는 모든 일정이 삭제됩니다. 진행하시겠습니까?"
      ) &&
      window.confirm("해당 작업은 취소할 수 없습니다. 정말로 진행하시겠습니까?")
    ) {
      deletePresetMutation.mutate(
        {
          id: presetId,
          group_code,
          project_code,
        },
        {
          onSuccess: () => {
            openSnackbar("프리셋을 삭제했습니다.");
          },
          onError: () => {
            openSnackbar("프리셋을 삭제 중 오류가 발생하였습니다.", "error");
          },
        }
      );
    }
  };
  if (editingPreset?.id === preset.id) {
    return (
      <EditPresetForm
        editingPreset={editingPreset}
        setEditingPreset={setEditingPreset}
        editMutation={editMutation}
        group_code={group_code}
        project_code={project_code}
        shiftsData={shiftsData}
      />
    );
  }
  const thisShift = shiftsData.find(
    (shift) => shift.shift_id === preset.shift_id
  );
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      <S.PresetCard elevation={3}>
        <S.PresetHeader>
          <S.TitleWithIconPreset>
            <ClockIcon color="primary" />
            <Typography variant="h6">{preset.name}</Typography>
            {preset.description !== "0" && preset.description && (
              <Typography variant="div">
                (메모 : {preset.description})
              </Typography>
            )}
          </S.TitleWithIconPreset>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <IconButton onClick={() => handleStartEdit(preset)} color="primary">
              <EditIcon />
            </IconButton>
            <IconButton onClick={() => deletePreset(preset.id)} color="error">
              <CloseIcon />
            </IconButton>
          </div>
        </S.PresetHeader>
        <S.TimeSlotsGridForNormalPreset>
          {preset.schedules.map((schedule) => (
            <S.TimeSlotPresetForNormal key={schedule.id}>
              <S.TimeDisplayForNormalPreset>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {schedule.shift_name}
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {schedule.start}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  ~
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {schedule.end === "00:00" ? "24:00" : schedule.end}
                </Typography>
              </S.TimeDisplayForNormalPreset>
            </S.TimeSlotPresetForNormal>
          ))}
        </S.TimeSlotsGridForNormalPreset>
      </S.PresetCard>
    </motion.div>
  );
}

export default PresetCard;
